<div class="post-user-categories-list-container">
  @if (formGroup && companyCategory$ | async; as cat) {
    <ul>
      @for (category of cat.categories; track category) {
        <app-category [category]="category" [categoryForm]="formGroup">
        </app-category>
      }
    </ul>
  }
</div>
